import React, { useState } from 'react';
import { resolveAsset } from '../api/client';
import { useT } from '../i18n';

// "Download PDF" control for a finished book. The PDF is rendered server-side by
// headless Chrome (see server/services/bookPdf.js) so Arabic contextual
// letter-shaping is correct — client-side html2canvas mangled the joins. The
// endpoint is paid-order-gated by shareToken, so the same plain fetch works for
// both the buyer and an admin viewing a paid order.
export default function BookDownload({ story, className }) {
  const t = useT();
  const [pdfBusy, setPdfBusy] = useState(false);

  const downloadPdf = async () => {
    if (pdfBusy || !story?.shareToken) return;
    setPdfBusy(true);
    try {
      const res = await fetch(resolveAsset(`/api/stories/${story.shareToken}/book.pdf`));
      if (!res.ok) {
        let msg = `HTTP ${res.status}`;
        try {
          const data = await res.json();
          if (data?.error) msg = data.error;
        } catch {}
        throw new Error(msg);
      }
      const blob = await res.blob();
      const safeTitle = (story.title || 'story').replace(/[\\/:*?"<>|]/g, '').trim().slice(0, 80) || 'story';
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${safeTitle}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('PDF generation failed:', err);
      alert('PDF generation failed: ' + (err?.message || 'unknown error'));
    } finally {
      setPdfBusy(false);
    }
  };

  return (
    <button
      type="button"
      className={className || 'pdf-btn'}
      onClick={downloadPdf}
      disabled={pdfBusy}
    >
      {pdfBusy ? t.downloadingPdf : t.downloadPdf}
    </button>
  );
}
